import { useState } from "react";
import { UsuarioDto } from "src/pages/Privada/Configuracoes/Usuario/Usuario.Dto";
import { UsuarioGestaoFiltrar } from "src/services/Identity.Service";

export const ConsultarUsuario = () => {
  const [loading, setLoading] = useState(false);

  const UsuarioBuscar = (query: string): Promise<UsuarioDto[]> => {
    setLoading(false);

    return new Promise<UsuarioDto[]>((resolve, reject) => {
      UsuarioGestaoFiltrar({ id: 0, nome: query })
        .then((response) => {
          if (response.data.success) {
            const data = response.data.data;
            resolve(data);
          } else {
            if (response.status === 204) {
              resolve([]);
            } else {
              response.data.notifications.forEach((err: any) =>
                console.log(err.message)
              );
              reject("Erro ao buscar dados");
            }
          }
        })
        .catch((error) => {
          console.log(error);
          reject("Erro ao buscar dados");
        })
        .finally(() => {
          setLoading(false);
        });
    });
  };

  return {
    UsuarioBuscar,
    loading,
  };
};
